export default {"src":"/_next/static/media/plus-disabled.0d59a40e.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};